<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col
      cols="12"
      md="6"
    >
      <SectionTitle class="sec-title">Se você está cansado de:</SectionTitle>
      <ul>
        <li>
          <v-icon color="red">mdi-close</v-icon>
          Atrasos ou erros nos pedidos
        </li>
        <li>
          <v-icon color="red">mdi-close</v-icon>
          Anotar as pedidos à mão
        </li>
        <li>
          <v-icon color="red">mdi-close</v-icon>
          Gastar horas respondendo os clientes no WhatsApp
        </li>
      </ul>
      <p class="highlighted-text mt-4">🎉 Parabéns, você encontrou a solução!</p>
      <CtaButton>Eu quero a solução</CtaButton>
    </v-col>

    <v-col
      cols="12"
      md="6"
      class="position-relative"
    >
      <v-img
        :src="require('@/assets/images/pains.png')"
        class="section-image"
        contain
        alt="dores"
        loading="eager"
      />

      <v-chip class="chip-label atrasos-label">
        <v-img
          :src="require('@/assets/images/emojis/atrasos.png')"
          class="mr-2"
          alt="atrasos"
        />
        Atrasos
      </v-chip>
      <v-chip class="chip-label processos-manuais-label">
        <v-img
          :src="require('@/assets/images/emojis/processos-manuais.png')"
          class="mr-2"
          alt="processos-manuais"
        />
        Processos manuais
      </v-chip>
      <v-chip class="chip-label atendimento-label">
        <v-img
          :src="require('@/assets/images/emojis/atendimento-demorado.png')"
          class="mr-2"
          alt="atendimento-demorado"
        />
        Atendimento demorado
      </v-chip>
      <v-chip class="chip-label estresse-label">
        <v-img
          :src="require('@/assets/images/emojis/estresse.png')"
          class="mr-2"
          alt="estresse"
        />
        Estresse
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
  import CtaButton from "@/components/CtaButton.vue";
  import SectionTitle from "@/components/SectionTitle.vue";

  export default {
    name: "Section",

    components: {
      CtaButton,
      SectionTitle,
    },
  };
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
    padding-left: 0;
    margin-top: 20px;
  }

  .highlighted-text {
    display: inline-block;
    margin-top: 20px;
    padding: 10px 18px;
    border-radius: 10px;
    border: 1px solid rgba(229, 9, 20, 0.5);
    background: linear-gradient(135deg, rgba(229, 9, 20, 0.08) 0%, rgba(229, 9, 20, 0.02) 100%);
    font-weight: 500;
    position: relative;
    overflow: hidden;
    animation: parabens-glow 3s ease-in-out infinite;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -75%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        120deg,
        transparent 0%,
        rgba(255, 255, 255, 0.12) 50%,
        transparent 100%
      );
      animation: parabens-shine 3s ease-in-out infinite;
    }
  }

  @keyframes parabens-glow {
    0%, 100% { box-shadow: 0 0 8px rgba(229, 9, 20, 0.15); }
    50%       { box-shadow: 0 0 18px rgba(229, 9, 20, 0.35); }
  }

  @keyframes parabens-shine {
    0%   { left: -75%; }
    60%, 100% { left: 125%; }
  }

  .section-image {
    border-radius: 20px;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden;

    ::v-deep .v-image__image {
      filter: blur(2px);
      transform: scale(1.03);
    }
  }

  .position-relative {
    position: relative;
    @media (max-width: 780px) {
      margin-top: 20px;
      .atrasos-label {
        top: 25px;
        left: 8px;
      }
      .processos-manuais-label {
        top: 90px;
        right: 8px;
      }
    }
  }

  .chip-label {
    position: absolute;
    padding: 6px 10px;
    border: 1px solid #e50914;
    border-radius: 12px;
    background-color: var(--chip-bg) !important;
    font-size: 20px;
    font-weight: 500;
    @media (max-width: 780px) {
      font-size: 14px;
    }
  }

  // .sec-title {
  //   @media (max-width: 780px) {
  //     font-size: 25px;
  //   }
  // }

  /* Animações flutuantes dos chips */
  @keyframes chip-float-a {
    0%   { transform: translate(0px,   0px); }
    25%  { transform: translate(5px,  -7px); }
    50%  { transform: translate(3px,  -5px); }
    75%  { transform: translate(-4px, -8px); }
    100% { transform: translate(0px,   0px); }
  }

  @keyframes chip-float-b {
    0%   { transform: translate(0px,   0px); }
    30%  { transform: translate(-6px, -5px); }
    55%  { transform: translate(-3px, -9px); }
    80%  { transform: translate(4px,  -4px); }
    100% { transform: translate(0px,   0px); }
  }

  @keyframes chip-float-c {
    0%   { transform: translate(0px,   0px); }
    20%  { transform: translate(-5px, -6px); }
    50%  { transform: translate(4px,  -8px); }
    75%  { transform: translate(6px,  -3px); }
    100% { transform: translate(0px,   0px); }
  }

  @keyframes chip-float-d {
    0%   { transform: translate(0px,   0px); }
    35%  { transform: translate(6px,  -4px); }
    60%  { transform: translate(3px,  -9px); }
    85%  { transform: translate(-5px, -5px); }
    100% { transform: translate(0px,   0px); }
  }

  /* Posições específicas para as etiquetas */
  .atrasos-label {
    top: 60px;
    left: 4px;
    animation: chip-float-a 4.3s ease-in-out infinite;
  }

  .processos-manuais-label {
    top: 190px;
    right: 4px;
    animation: chip-float-b 3.7s ease-in-out infinite 0.8s;
  }

  .atendimento-label {
    bottom: 110px;
    left: 4px;
    animation: chip-float-c 5.1s ease-in-out infinite 0.4s;
  }

  .estresse-label {
    bottom: 70px;
    right: 4px;
    animation: chip-float-d 4.6s ease-in-out infinite 1.2s;
  }
</style>
